import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import * as GroupActions from "src/app/store/group/group.actions";
import { Observable } from "rxjs";
import { AppState } from "../app.reducer";
import { SchoolGroup } from "@core/models/domain/group.domain";
import { selectActiveGroups, selectAllGroups, selectGroupById, selectGroupError, selectGroupLoading, selectGroupsSettled } from "./group.selectors";
import { CreateSchoolGroupRequest, ModifySchoolGroupRequest } from "@core/models/request/group.request";

@Injectable({ providedIn: 'root' })
export class GroupStoreFacade {
    groups$: Observable<SchoolGroup[]> = this.store.select(selectAllGroups);
    // Memoized list view: ACTIVE groups only.
    activeGroups$: Observable<SchoolGroup[]> = this.store.select(selectActiveGroups);
    error$: Observable<string | null> = this.store.select(selectGroupError);
    loading$: Observable<boolean> = this.store.select(selectGroupLoading);
    /** True once groups are loaded or the last load failed. */
    groupsSettled$: Observable<boolean> = this.store.select(selectGroupsSettled);

    constructor(private store: Store<AppState>) {}

    // Store-first: renders the cached groups instantly and only fetches when the
    // cache is empty, stale or invalidated.
    loadGroupsIfNeeded(): void {
        this.store.dispatch(GroupActions.loadGroupsIfNeeded());
    }

    loadGroups(): void {
        this.store.dispatch(GroupActions.loadGroups());
    }

    createGroup(request: CreateSchoolGroupRequest): void {
        this.store.dispatch(GroupActions.createGroup({ request }));
    }

    updateGroup(request: ModifySchoolGroupRequest): void {
        this.store.dispatch(GroupActions.updateGroup({ request }));
    }

    removeGroup(groupId: string, acknowledgeStrandedPupils = false): void {
        this.store.dispatch(GroupActions.deleteGroup({ groupId, acknowledgeStrandedPupils }));
    }

    getGroup(groupId: string): Observable<SchoolGroup | undefined> {
        return this.store.select(selectGroupById(groupId));
    }
}